//теперь UTF-8
export const validateInn = function(inn) {
    if (!inn || inn.match(/\D/))
        return false;
    inn = inn.match(/(\d)/g) || '';
    if (inn && inn.length === 10) {
        return inn[9] === String(((
            2 * inn[0] + 4 * inn[1] + 10 * inn[2] +
            3 * inn[3] + 5 * inn[4] + 9 * inn[5] +
            4 * inn[6] + 6 * inn[7] + 8 * inn[8]
        ) % 11) % 10);
    } else if (inn.length === 12) {
        return inn[10] === String(((
            7 * inn[0] + 2 * inn[1] + 4 * inn[2] +
            10 * inn[3] + 3 * inn[4] + 5 * inn[5] +
            9 * inn[6] + 4 * inn[7] + 6 * inn[8] +
            8 * inn[9]
        ) % 11) % 10) && inn[11] === String(((
            3 * inn[0] + 7 * inn[1] + 2 * inn[2] +
            4 * inn[3] + 10 * inn[4] + 3 * inn[5] +
            5 * inn[6] + 9 * inn[7] + 4 * inn[8] +
            6 * inn[9] + 8 * inn[10]
        ) % 11) % 10);
    }
    return false;
};

export const validateOgrn = function(value) {
    value = '' + value;
    if (!(/^\d{13}$/.test(value))) {
        return false;
    }
    return parseInt((value.slice(0, -1) % 11).toString().slice(-1)) === +value[12];
};

// стандартный бутстраповский попап
export const modalPopup = function(options) {
    var v = $.extend({
            id: 'dynamic-modal-popup',
            title: '',
            content: '',
            footer: '<div class="text-center">' +
                '<button type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>' +
                '</div>',
            show: true
        }, options),
        $modal = $('#' + v.id);
    if ($modal.length)
        $modal.remove();
    $modal = $('<div id="' + v.id + '" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content">' +
        '<div class="modal-header"><h4 class="modal-title"></h4><button type="button" class="close" data-dismiss="modal" aria-label="Закрыть"><span aria-hidden="true">&times;</span></button></div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div></div></div></div>').appendTo('body');
    $modal.find('.modal-title').html(v.title);
    $modal.find('.modal-body').html(v.content);
    $modal.find('.modal-footer').html(v.footer);
    if (v.onClose)
        $modal.on('hidden.bs.modal', v.onClose);
    $modal.modal({ show: v.show });
    return $modal;
};

export const modalConfirm = function(options) {
    if (!options.footer)
        options.footer = '<div class="text-center">' +
        '<button type="button" class="btn btn-primary mr-3 action-ok">Ok</button>' +
        '<button type="button" class="btn btn-secondary" data-dismiss="modal">Отмена</button>' +
        '</div>';
    const $modal = modalPopup(options);
    $modal.find('button.action-ok').click(function() {
        if (typeof options.onConfirm === 'function')
            $modal.on('hidden.bs.modal', options.onConfirm);
        $modal.modal('hide');
    });
    return $modal;
};


export const promiseRequest = function(options) {
    return new Promise(function(resolve, reject) {
        $.ajax(
            Object.assign({}, options, {
                success: function(response) {
                    if (response.success) {
                        resolve(response.data);
                    }
                    if (response.errors) {
                        reject(response.errors);
                    }
                },
                error: function() {
                    reject(
                        'При загрузке данных произошла ошибка. Повторите попытку позже'
                    );
                },
            })
        );
    });
}

/**
 * Проверяет ответ на аякс запрос и показывает попап с ошибкой, если запрос был неудачным
 * @param {Object} response
 * @param {String} unknownError - текст ошибки в случае если ошибка не указана в ответе на запрос
 * @returns {Boolean}
 */
export const showResponseError = function(response, unknownError) {
    if (!response || !response.success) {
        var error = response && response.errors ?
            ($.isArray(response.errors) ?
                '<ul><li>' + response.errors.join('</li><li>') + '</li></ul>' :
                response.errors) :
            (unknownError || 'Неизвестная ошибка');
        modalPopup({
            title: 'Ошибка',
            content: '<div class="alert alert-danger">' + error + '</div>'
        });
        return true;
    }
}


export const showErrorsInModal = function(errors) {
    if(!errors) {
        return;
    }

    var errs = $.isArray(errors) ? '<ul><li>' + errors.join('</li><li>') + '</li></ul>' : errors
    modalPopup({
        title: 'Ошибка',
        content: '<div class="alert alert-danger">' + errs + '</div>'
    });
    return true;
}


export const getFakeId = function() {
    return 'f_' + Math.random().toString(36).substr(2, 9);
}

export const isFakeId = function(id) {
    return String(id)[0] === 'f' && String(id)[1] === '_';
}

export const debounce = function(n,l,u){var t,e,a,o,r;function i(){var c=Date.now()-o;c<l&&c>=0?t=setTimeout(i,l-c):(t=null,u||(r=n.apply(a,e),a=e=null))}null==l&&(l=100);var c=function(){a=this,e=arguments,o=Date.now();var c=u&&!t;return t||(t=setTimeout(i,l)),c&&(r=n.apply(a,e),a=e=null),r};return c.clear=function(){t&&(clearTimeout(t),t=null)},c.flush=function(){t&&(r=n.apply(a,e),a=e=null,clearTimeout(t),t=null)},c}
